module.exports = __webpack_public_path__ + "static/img/UTSG老师_Betty.47f2c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG老师_Betty.png
// module id = V02T
// module chunks = 0